import { render, staticRenderFns } from "./FinanceIcon.vue?vue&type=template&id=37046a27"
import script from "./FinanceIcon.vue?vue&type=script&lang=js"
export * from "./FinanceIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports